'use client';

import { useEffect, useState } from 'react';
import clsx from 'clsx';
import Button, { ButtonType } from '@/components/Button/Button';
import styles from './ImageWithVideo.module.scss';
import { mediaPath } from '@/mediaPath';
import Text from '@/components/Text/Text';

interface IImageWithVideo {
  data: {
    title: string;
    description: string;
    background: { height: number, width: number, url: string };
    buttons: {
      id: number,
      title: string,
      type: ButtonType,
      link: string,
      iconName: string,
    }[],
    video: {
      id: number,
      alternativeText: string | null,
      width: number,
      height: number,
      url: string,
    }
  },
  textPosition?: 'bottom' | 'top'
}

const ImageWithVideo = ({ data, textPosition = 'top' }: IImageWithVideo) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const handleOpenModal = () => setIsVideoModalOpen(true);
  const handleCloseModal = () => setIsVideoModalOpen(false);

  useEffect(() => {
    document.documentElement.style.overflow = isVideoModalOpen ? 'hidden' : 'unset';
  }, [isVideoModalOpen]);
  const background = mediaPath(data.background.url);
  const video = data.video ? mediaPath(data.video.url) : null;

  return (
    <section className={styles.imageWithVideoWrap}>
      <section
        className={styles.imageWithVideo}
        style={{
          backgroundImage:
          `radial-gradient(113.99% 52.97% at 30.58% 10.24%, rgba(54, 23, 9, 0.3) 59.76%, rgba(54, 23, 9, 0) 100%), url(${background})`,
        }}
      >
        <div className={clsx(styles.imageWithVideoContent, styles[textPosition])}>
          <div className={styles.textContent}>
            <Text
              tag='h2'
            >
              {data.title}
            </Text>
            {data.description && <p>{data.description}</p>}
          </div>
          <div className={styles.actions}>
            {data.buttons.map((btn) => (
              <div
                key={btn.id}
                className={styles.buttonContainer}
              >
                <Button
                  key={btn.id}
                  type={btn.type}
                  href={btn?.link}
                  iconName={btn?.iconName}
                  onClick={btn?.iconName === 'play_circle' ? handleOpenModal : () => {}}
                >
                  {btn.title}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>
      {isVideoModalOpen && video && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <Button
              type={ButtonType.SECONDARY_DARK}
              onClick={handleCloseModal}
              iconName='close'
              className={styles.closeButton}
              ariaLabel='Close video modal'
            >
              Close video
            </Button>
            <video
              controls
            >
              <source
                src={video}
                type='video/mp4'
              />
              <track kind='captions' />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageWithVideo;
